import {useMutation, useQueryClient} from "react-query";
import {BrandingService} from "../../../services/BrandingService";
import {useParams, useNavigate} from "react-router-dom";
import Alert from "react-s-alert";

export const useDeleteBrandingTheme = () => {
  const {organizationId} = useParams<{organizationId: string}>();
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  return useMutation(
    async (themeId: string) => {
      const response = await BrandingService.deleteTheme(
        organizationId,
        themeId,
      );
      return response.data;
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: ["themes"],
        });
        navigate(`/admin/organizations/${organizationId}/edit`);
        Alert.success("Theme deleted successfully");
      },
      onError: () => {
        Alert.error("Failed to delete theme");
      },
    },
  );
};
